import { j as json, e as error } from "../../../../../../chunks/index2.js";
import admin from "firebase-admin";
import { u as updateInstallerProgress } from "../../../../../../chunks/utils.js";
import { G as GITHUB_USER } from "../../../../../../chunks/private.js";
import { o as octokit, t as triggerWorkflow, w as waitUntilWorkflowInProgress, g as getWorkflowJob } from "../../../../../../chunks/octokit.js";
const beginDownload = async (user) => {
  try {
    const usersByEmail = await admin.firestore().collection("users").where("email", "==", user.email).get();
    const ids = usersByEmail.docs.map((doc) => doc.data()).map((data2) => data2.id);
    const branch = `user/${user.email}`;
    const { data } = await octokit.rest.repos.getCommit({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: "refs/heads/main"
    });
    await octokit.rest.git.deleteRef({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: `heads/${branch}`
    });
    await octokit.rest.git.createRef({
      owner: GITHUB_USER,
      repo: "glimmr",
      ref: `refs/heads/${branch}`,
      sha: data.sha
    });
    await triggerWorkflow(branch, ids.join(","));
    const workflow = await waitUntilWorkflowInProgress(branch);
    const job = await getWorkflowJob(workflow.id);
    await updateInstallerProgress(user.email, {
      workflowId: workflow.id,
      jobId: job.id
    });
  } catch (err) {
    await updateInstallerProgress(user.email, {
      status: "error"
    });
  }
};
const GET = async ({ locals }) => {
  if (locals.user) {
    await admin.firestore().collection("installers").doc(locals.user.email).set({
      status: "pending"
    });
    await beginDownload(locals.user);
    return json({
      success: true
    });
  }
  return error(403, { message: "Unauthorized" });
};
export {
  GET
};
